module.exports = __webpack_public_path__ + "static/media/default2.72a3bf9b.jpg";